import { makeRequest } from 'utils/requestLogger';

export default (live_discussion_id, payload) =>
    makeRequest(
        'post',
        `/api/live_discussions/${live_discussion_id}/sync-assessment-data`, payload
    );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/syncLDAssessmentData.js